var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3766_11890)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18182 12C8.83036 12 8.54545 12.2849 8.54545 12.6364C8.54545 12.9878 8.83036 13.2727 9.18182 13.2727H14.2727C14.6242 13.2727 14.9091 12.9878 14.9091 12.6364C14.9091 12.2849 14.6242 12 14.2727 12H9.18182Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54545 15.1818C8.54545 14.8304 8.83036 14.5455 9.18182 14.5455H14.2727C14.6242 14.5455 14.9091 14.8304 14.9091 15.1818C14.9091 15.5333 14.6242 15.8182 14.2727 15.8182H9.18182C8.83036 15.8182 8.54545 15.5333 8.54545 15.1818Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18182 9.45455C8.83036 9.45455 8.54545 9.73946 8.54545 10.0909C8.54545 10.4424 8.83036 10.7273 9.18182 10.7273H10.4545C10.806 10.7273 11.0909 10.4424 11.0909 10.0909C11.0909 9.73946 10.806 9.45455 10.4545 9.45455H9.18182Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55916 5.55916C6.91718 5.20114 7.40277 5 7.90909 5H13C13.1688 5 13.3306 5.06705 13.45 5.18639L17.2682 9.00457C17.3875 9.12391 17.4545 9.28577 17.4545 9.45455V17.0909C17.4545 17.5972 17.2534 18.0828 16.8954 18.4408C16.5374 18.7989 16.0518 19 15.5455 19H7.90909C7.40277 19 6.91718 18.7989 6.55916 18.4408C6.20114 18.0828 6 17.5972 6 17.0909V6.90909C6 6.40277 6.20114 5.91718 6.55916 5.55916ZM7.90909 6.27273C7.74032 6.27273 7.57846 6.33977 7.45911 6.45911C7.33977 6.57846 7.27273 6.74032 7.27273 6.90909V17.0909C7.27273 17.2597 7.33977 17.4215 7.45911 17.5409C7.57846 17.6602 7.74032 17.7273 7.90909 17.7273H15.5455C15.7142 17.7273 15.8761 17.6602 15.9954 17.5409C16.1148 17.4215 16.1818 17.2597 16.1818 17.0909V10.0909H13C12.6485 10.0909 12.3636 9.806 12.3636 9.45455V6.27273H7.90909ZM13.6364 7.17268L15.2819 8.81818H13.6364V7.17268Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3766_11890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.fe602d0a2049efd760b086c634e3225b.svg";
export { ForwardRef as ReactComponent };